<as-split
  [direction]="'horizontal'"
  [unit]="'pixel'"
  [gutterSize]="DRAG_TARGET"
  [useTransition]="true"
  [gutterDblClickDuration]="300"
  (dragEnd)="sizeChanged($event)"
>
  <!--<div
    *asSplitGutter="let gutterNum = gutterNum; let first = first; let last = last"
    class="custom-collapse-gutter"
    [ngClass]="state.assetTreeAsSplitWidth === 0 ? 'wide-gutter' : 'narrow-gutter'"
  >
    <div asSplitGutterExcludeFromDrag class="pointer">
      <div class="custom-collapse-gutter-header border-r" (click)="gutterClick()">
        @if (state.assetTreeAsSplitWidth === 0) {
          <dojo-icon [icon]="'chevrons-right'" [size]="12" class="text-gray-700" />
        } @else {
          <dojo-icon [icon]="'chevrons-left'" [size]="12" class="text-gray-700" />
        }
      </div>
      <div class="custom-collapse-gutter-icon"></div>
      <div class="custom-collapse-gutter-ghost"></div>
    </div>
  </div>-->
  <as-split-area
    #assetTreeSplitArea
    [minSize]="MIN_LEFT_NAV_WIDTH_PX"
    [maxSize]="MAX_LEFT_NAV_WIDTH_PX"
    [size]="state.assetTreeAsSplitWidth"
    class="collapsible-area-split flex"
  >
    <!-- added extra wrappers here to keep the order of sidebar elements -->
    <div class="w-full flex-shrink-0" [class.pt-8]="hasPadding">
      <exam-asset-explorer [readonly]="readOnly" @appearDisappear />
    </div>
  </as-split-area>

  <!-- Main content -->
  <as-split-area [size]="sizeWildcard" class="main-content-area">
    <ng-content />
  </as-split-area>
</as-split>
